export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
export const ADD_NEW_NOTIFICATION = 'ADD_NEW_NOTIFICATION';
export const MARK_AS_READ = 'MARK_AS_READ';
export const MARK_ALL_SEEN = 'MARK_ALL_SEEN';
export const MARK_ALL_READ = 'MARK_ALL_READ';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const EXPIRE_NOTIFICATION = 'EXPIRE_NOTIFICATION';
